import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';

import Container from "../../../../../base/components/container.js";
import DisclaimerBlock from "../../../../../base/components/disclaimer_block.js";
import I18n from "../../../../../base/i18n.js.jsx";
import LoadProjectsListUseCase from "../../../../../use_cases/projects/projects/load_projects_list_use_case.js.jsx";

import ProjectItem from "./project_item.js";

const blockStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.white,
    position: "relative",
  },
  content: {
    padding: "50px 16px 70px",
    ['@media (max-width: 992px)']: {
      padding: "40px 16px 50px",
    },
    ['@media (max-width: 768px)']: {
      padding: "32px 24px 40px",
    },
  },
  title: {
    display: "block",
    fontSize: "38px",
    textTransform: "uppercase",
    marginBottom: "30px",
    ['@media (max-width: 992px)']: {
      fontSize: "32px",
      marginBottom: "28px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "20px",
      lineHeight: "26px",
      marginBottom: "24px",
    },
  },
  text: {
    display: "block",
    fontWeight: theme.typography.fontWeightLight,
    fontSize: "20px",
    ['@media (max-width: 992px)']: {
      fontSize: "18px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
  itemContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "45px",
    ['@media (max-width: 768px)']: {
      marginTop: "32px",
    },
  },
  disclaimer: {
    marginTop: "65px",
    ['@media (max-width: 768px)']: {
      marginTop: "36px",
    },
  }
}));

const ProjectsBlock = (props) => {
  const classes = blockStyles();
  const { id } = props;

  const [loaded, setLoaded] = useState(false);
  const [projects, setProjects] = useState([]);
  const [participantsMap, setParticipantsMap] = useState({});

  useEffect(() => {
    LoadProjectsListUseCase.execute(paginationInfo())
    .then((result) => {
      const { data: { projects, participants } } = result;
      let participantsMap = {};
      (participants || []).forEach((participant) => {
        participantsMap[participant.projectId] = participant;
      })
      setProjects(projects);
      setParticipantsMap(participantsMap);
      setLoaded(true);
    })
  }, [props.recoveredAt])

  const paginationInfo = () => {
    return {
      page: 1,
      perPage: 100
    }
  }

  return (
    <div className = { classes.root }
         id = { id } >
      <Container className = { classes.content } >
        <div className = { classes.column } >
          <span className = { classes.title} >
            { I18n.t("web.page.index.projects.title") }
          </span>
          {
            loaded &&
            <div className = { classes.itemContainer }>
              { 
                projects.map((project) => {
                  const { id: key } = project;
                  const participant = participantsMap[key];
                  return <ProjectItem project = { project } 
                                      participant = { participant }
                                      key = { key } />
                })
              }
            </div>
          }
        </div>
        <DisclaimerBlock className = { classes.disclaimer }/>
      </Container>
    </div>
  );
}

export default ProjectsBlock;